import { render, staticRenderFns } from "./VariantsListCarousel.vue?vue&type=template&id=aa661396"
import script from "./VariantsListCarousel.vue?vue&type=script&lang=js"
export * from "./VariantsListCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommercialOperationBadge: require('/app/components/CommercialOperationBadge.vue').default,ProductStockStatus: require('/app/components/ProductStockStatus.vue').default})
